import { Col, Flex, message, Row } from "antd";
import { SmsTemplateFormCard } from "./components/SmsTemplateForm";
import { useMutation, useQuery } from "@tanstack/react-query";
import { SmsTemplate } from "@rumble-it/common-lib/types/models/SmsTemplate.interface";
import {
  fetchSmsTemplateById,
  updateSmsTemplateById,
} from "../../../lib/api/resources/sms";
import { useNavigate, useParams } from "react-router-dom";

export const SmsTemplateEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const smsTemplateQuery = useQuery({
    queryKey: ["smsTemplate", id],
    queryFn: () => fetchSmsTemplateById(id),
  });

  const updateSmsTemplateMutation = useMutation({
    mutationFn: (data: SmsTemplate) => updateSmsTemplateById(id, data),
    onSuccess: () => {
      navigate(`/sms-templates/${id}`);
      message.success("SMS Template succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van de SMS Template",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <SmsTemplateFormCard
              loading={smsTemplateQuery.isLoading}
              initialValues={smsTemplateQuery.data}
              mutation={updateSmsTemplateMutation}
              title="SMS Template Bijwerken"
              buttonText="Bijwerken"
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
